import { useRef, useState } from 'react';
import QuotationTemplate from './QuotationTemplate';

export default function QuotationPreview({ data, catalog, onSave, onDownload }) {
  const templateRef = useRef(null);
  const [generating, setGenerating] = useState(false);

  const handleDownloadPDF = async () => {
    if (!templateRef.current || generating) return;
    setGenerating(true);
    try {
      const html2pdf = (await import('html2pdf.js')).default;

      const selectedAgent = (catalog.agents || []).find(a => a.agent_identity_id === data.agent_identity_id);
      const clientName = data.client_name || 'Cliente';
      const today = new Date().toISOString().slice(0, 10);
      const refType = data.reference_type || 'Cotizacion';
      const filename = `Cotizacion ${refType} ${today} (${selectedAgent?.name || 'Asesor'}-${clientName}).pdf`;

      const opt = {
        margin: [10, 10, 15, 10],
        filename,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'], avoid: ['.no-break'] }
      };

      await html2pdf().set(opt).from(templateRef.current).save();

      if (onDownload) onDownload();
    } catch (err) {
      console.error('Error generating PDF:', err);
      alert('Error al generar PDF: ' + err.message);
    }
    setGenerating(false);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Action buttons */}
      <div className="flex gap-2 mb-4 sticky top-0 z-10 bg-gray-100 pb-3 pt-1">
        <button
          onClick={onSave}
          className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition text-sm font-medium"
        >
          Guardar borrador
        </button>
        <button
          onClick={handleDownloadPDF}
          disabled={generating}
          className={`px-4 py-2 rounded-lg transition text-sm font-medium
            ${generating
              ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        >
          {generating ? 'Generando PDF...' : 'Descargar PDF'}
        </button>
      </div>

      {/* Preview container */}
      <div className="flex-1 overflow-y-auto">
        <div
          className="bg-white shadow-lg mx-auto"
          style={{
            transform: 'scale(0.65)',
            transformOrigin: 'top center',
            width: '216mm',
          }}
        >
          <QuotationTemplate ref={templateRef} data={data} catalog={catalog} />
        </div>
      </div>
    </div>
  );
}
